import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import * as React from 'react';
import {
  GREEN_COLOR,
  RED_COLOR,
} from '../../../../../../constants/ColorsConst';

const ChartEstudiantePlanEvaluacion = ({ estudiantes, instrumentos }) => {
  const [categories, setCategories] = React.useState([]);
  const [aprobadosData, setAprobadosData] = React.useState([]);
  const [reprobadosData, setReprobadosData] = React.useState([]);

  React.useEffect(() => {
    setCategories([]);
    setAprobadosData([]);
    setReprobadosData([]);

    let datas = [];
    let list = [];
    instrumentos.forEach((a) => {
      list.push(a.instrumento.nombre);
      datas.push({
        ...a,
        aprobados: 0,
        reprobados: 0,
      });
    });
    setCategories(list);

    datas.forEach((el) => {
      const { aprobados, reprobados } = estudiantes.reduce(
        (acc, estudiante) => {
          if (estudiante.notasEvaluativas.length > 0) {
            estudiante.notasEvaluativas.forEach((nota) => {
              if (nota.ptevaInstrumento.id === el.id) {
                if (parseInt(nota.nota) >= 10) {
                  acc.aprobados += 1;
                } else {
                  acc.reprobados += 1;
                }
              }
            });
          }
          return acc;
        },
        { aprobados: 0, reprobados: 0 },
      );

      setAprobadosData((prev) => [...prev, el.aprobados + aprobados]);
      setReprobadosData((prev) => [...prev, el.reprobados + reprobados]);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estudiantes]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          type: 'column',
        },
        title: {
          text: `Total de estudiantes por actividades`,
          align: 'center',
        },
        xAxis: {
          categories,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total de estudiantes',
          },
          stackLabels: {
            enabled: false,
          },
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          align: 'center',
          x: 50,
          verticalAlign: 'top',
          y: 30,
          floating: true,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || 'white',
          borderColor: '#fff',
          borderWidth: 1,
          shadow: false,
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}',
        },
        series: [
          {
            name: 'APROBADOS',
            data: aprobadosData,
            color: GREEN_COLOR,
          },
          {
            name: 'REPROBADOS',
            data: reprobadosData,
            color: RED_COLOR,
          },
        ],
      }}
    />
  );
};

export default ChartEstudiantePlanEvaluacion;
